import { SimCardFragment } from "@phonero/common-ux"
import { PuxButton, PuxIcon, PuxText, useTranslation } from "@phonero/pux-react"
import React from "react"
import { arrowMore } from "@phonero/pux-icons/icons"
import { ActivateSimDialogue } from "../ShinySimCard"

export const ReadyForActivationDetails = ({
  card,
}: {
  card: SimCardFragment
}) => {
  const { t } = useTranslation()
  const [showActivationDialog, setShowActivationDialog] = React.useState(false)
  return (
    <>
      <PuxButton
        color="primary"
        size="default"
        onClick={() => setShowActivationDialog(true)}
        slot="end"
      >
        <PuxText
          slot="start"
          style={{
            fontSize: "17px",
            fontWeight: "600",
            width: "120px",
            textAlign: "left",
          }}
        >
          {t("General.Activate")}
        </PuxText>
        <PuxIcon
          slot="end"
          icon={arrowMore}
          style={{
            fontSize: "1.5rem",
            marginLeft: 5,
          }}
        ></PuxIcon>
      </PuxButton>
      <ActivateSimDialogue
        isOpen={showActivationDialog}
        onClose={() => setShowActivationDialog(false)}
        id={card.id}
      />
    </>
  )
}
